import {ampLogInfo, ampLogError, getCookie, setCookie} from './util'

//  https://en.wikipedia.org/wiki/List_of_ISO_3166_country_codes

const GDPRCountries = [
	["at","Austria"  ],
	["be","Belgium"  ],
	["bg","Bulgaria"  ],
	["hr","Croatia"  ],
	["cy","Cyprus"  ],
	["cz","Czech Republic"  ],
	["dk","Denmark"  ],
	["ee","Estonia"  ],
	["fi","Finland"  ],
	["fr","France"  ],
	["de","Germany"  ],
	["gb","Great Britain"  ],
	["gr","Greece"  ],
	["hu","Hungary"  ],
	["is","Iceland"  ],
	["ie","Ireland"  ],
	["it","Italy"  ],
	["lv","Latvia"  ],
	["li","Liechtenstein"  ],
	["lt","Lithuania"  ],
	["lu","Luxembourg"  ],
	["mt","Malta"  ],
	["nl","Netherlands"  ],
	["no","Norway"  ],
	["pl","Poland"  ],
	["pt","Portugal"  ],
	["ro","Romania"  ],
	["sk","Slovakia"  ],
	["si","Slovenia"  ],
	["es","Spain"  ],
	["se","Sweden"  ]
];

const kAmpPioegCookieName = "amp_pieog";

function encodingToLocationDataObject( encodedResponse ) {
    let respString = atob(encodedResponse.split("").reverse().join(""));
    return( JSON.parse( respString ) );
}

function requestGeoIP( callback ) {

    // this function sends the user's IP address to a CloudFlare
    // web worker that returns geo lookup information from
    // CloudFlare's server headers.

    // callback function receives an object with the location data
    // or an object with status == 'failure'

    let xmlhttp = new XMLHttpRequest();

    xmlhttp.onreadystatechange = function() {

        if (xmlhttp.readyState == XMLHttpRequest.DONE) {   // XMLHttpRequest.DONE == 4
            if (xmlhttp.status == 200) {
                let encodedResponse = xmlhttp.responseText;
                setCookie(  kAmpPioegCookieName, encodedResponse, 7);
                let locationData = encodingToLocationDataObject( encodedResponse );
                locationData.status = "success";
                callback( locationData )
            }
            else {
                ampLogInfo('Geo IP lookup error ' + xmlhttp.status );
                callback( { status:"failure", httpStatus:xmlhttp.status } );
            }
        }
    };

    ampLogInfo( "Requesting Service Worker Geolocation");
    xmlhttp.open("GET", 'https://pioeg.admetricspro.workers.dev', true);
    xmlhttp.send();
}

function getLocationDataFromCookieOrService( locationDataCallback ) {
    // check the cookie first...

    let encodedResponse = getCookie( kAmpPioegCookieName );
    if ( encodedResponse && encodedResponse.length > 0) {
        ampLogInfo( "Geolocation data found in browser cache" );
        let locationData = encodingToLocationDataObject( encodedResponse );
        locationData.status = "success";
        locationDataCallback( locationData )
        return;
    }

    // no cookie? hit the service...

    requestGeoIP( locationDataCallback );
}

function getVisitorCountryAndRegion( callback  ) {

    if ( typeof callback !== "function" ) {
        ampLogError( "getVisitorCountryAndRegion() : callback parameter must be defined");
        return;
    }

    let locationDataCallback = function( locationData ) {

        if (locationData.status != "success") {
            ampLogInfo( "geo IP query failed" );
            callback(  false, "", "" );
        }
        else { 
            const cc = locationData.country.split('-')[0];
            
            if ( cc != "US" ) {
                callback( true, cc, "" );
            }

            if ( locationData.regionCode && locationData.region ) {
                callback( true, cc,locationData.regionCode );
                }
            else {
                callback( true, cc, "" );
                }
            }
        }

    getLocationDataFromCookieOrService( locationDataCallback );
}


function isUserInCalifornia( callback  ) {

    // Calls the callback function with a value of true or false indicating
    // whether the current visitor is in California (used for CCPA).

    // Under the hoods checks for location data in a first party cookie, and if
    // found extracts the country code and state.

    // If no cookie is found, the location data is retrieved from the CloudFlare
    // web worker, saved in the cookie, and then the country code and state.

    if ( typeof callback !== "function" ) {
        ampLogError( "isUserInCalifornia() : callback parameter must be defined");
        return;
    }


    let locationDataCallback = function( succeeded, countryCode, stateCode ) {

        if (! succeeded) {
            ampLogInfo( "geo IP query failed; assuming CCPA does not apply" );
            callback( false );
        }
        else { 
            const cc = locationData.country.split('-');

            const gdprApplies = ( GDPRCountries.find( (e) => e[0] === cc ) !== undefined );
            
            if ( locationData.country !="US" ) {
                ampLogInfo( "geo IP found country " + locationData.country +"; CCPA does not apply" );
                callback( false );
            }

            if ( locationData.regionCode && locationData.region ) {
                if ( locationData.regionCode == "CA" ) {
                    ampLogInfo( "USP applies to " + locationData.region  )
                    callback( true );
                    }
                else {
                    ampLogInfo( "USP does not apply to " + locationData.region  )
                    callback( false );
                    }
                }
            else {
                ampLogInfo( "No location region in geo IP loookup; assuming non-US geography"  )
                callback( false );
                }
            }
        }

     getLocationDataFromCookieOrService( locationDataCallback );
}

function isGDPRCountry( cc ) {
    const gdprApplies = ( GDPRCountries.find( (e) => e[0] === cc.toLowerCase() ) !== undefined );
    return ( gdprApplies)
}

function isUserInGDPRCountry( callback  ) {

    // Calls the callback function with a value of true or false indicating
    // wether the current visitor is in a GDPR-applicable geography.

    // Under the hoods checks for location data in a first party cookie, and if
    // found extracts the country code and checks it against the list at the top
    // of this file.

    // If no cookie is found, the location data is retrieved from the CloudFlare
    // web worker, saved in the cookie, and then the country code is checked
    // against the list at the top of the file.

    if ( typeof callback !== "function" ) {
        ampLogError( "isUserInGDPRCountry() : callback parameter must be defined");
        return;
    }

    let locationDataCallback = function( locationData ) {

        let locationDataCallback = function( locationData ) {
            try {
                if (locationData.status != "success") {
                    ampLogInfo( "geo IP query failed; assuming GDPR does not apply" );
                    callback( false );
                }
                else { 
                    const cc = locationData.country.toLowerCase();
                    const gdprApplies = ( GDPRCountries.find( (e) => e[0] === cc ) !== undefined );
                    
                    ampLogInfo( "geo IP found country " + locationData.country + "; GDPR " + ( gdprApplies ? "applies." : "does not apply." ) );
                    
                    callback( gdprApplies );
                }
            } catch (error) {
                ampLogError("An error occurred while processing location data: " + error);
            }
        }


        }

    getLocationDataFromCookieOrService( locationDataCallback );
}

export { isUserInCalifornia, isUserInGDPRCountry, getVisitorCountryAndRegion, isGDPRCountry };